module.exports = ".labelBold {\r\n    font-weight: bold;\r\n}"